import React from 'react'
import { Route, Switch } from 'react-router-dom'
import { AppWrap } from 'apps/marketplace/components/AppWrap'
import { ShipperConfig } from 'apps/spot-quote-control-panel/components/ShipperConfig'
import RouteNotFound from 'components/404'
import { SpotControlPanelHome } from './SpotControlPanelHome'

export const appName = 'spot-control-panel'

export const App = () => (
  <AppWrap appName={appName} title='Spot Control Panel'>
    <Switch>
      <Route exact path='/:id' component={ShipperConfig} />
      <Route exact path='/' component={SpotControlPanelHome} />
      <Route component={RouteNotFound} />
    </Switch>
  </AppWrap>
)
